
import { Component, Vue } from 'vue-property-decorator';
import { getCustomerList, customerExport } from '@/api/statistics';
import { UserModule } from '../../store/modules/user';
import DialogCustomer from "@/components/CustomerDialog/levelByLevel.vue";

@Component({
  name: 'StatisticsCustomer',
  components: {
    DialogCustomer
  }
})
export default class extends Vue {
  private formSearch:any = {
    name: '',
    timePeriods: '',
    startTime: '',
    endTime: '',
    customer: {}
  }
  // private pickerOptions:any = {
  //   disabledDate(time: any) {
  //     let y = new Date().getFullYear();
  //     let m = new Date().getMonth();
  //     let d = new Date().getDate();
  //     return time.getTime() >= new Date(y, m, d, 0, 0, 0);
  //   }
  // }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, start]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  private customerVisible = false
  private selectCustomer() {
    this.customerVisible = true;
  }
  private closecustomerHandle(val: boolean) {
    this.customerVisible = val;
  }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  private handleCurrentChange(page:number) {
    this.pagination.currentPage = page;
    this.getList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSizes = size;
    this.getList();
  }

  private loading = false
  private tableData = []
  private selectedData: string[] = [];
  private handleSelected(val:any[]) {
    this.selectedData = val;
  }
  // 导出Excel
  private handleExport() {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName
    };
    let customerCompanyIds = '';
    if (this.selectedData && this.selectedData.length > 0) {
      for (let i of this.selectedData) {
        let item:any = i;
        let customerId = '';
        if (parseInt(item.customer_company_id) === 0 || !item.customer_company_id) {
          customerId = 'p' + item.user_id;
        } else {
          customerId = item.customer_company_id;
        }
        customerCompanyIds = customerCompanyIds + customerId + ',';
      }
      params.customer_ids = customerCompanyIds.substring(0, customerCompanyIds.length - 1);
    }
    if (this.formSearch.customer && this.formSearch.customer.customer_company_id) {
      params.customer_company_id = this.formSearch.customer.customer_company_id;
    }
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      params.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    // params.start_time = parseInt(this.formSearch.startTime) / 1000;
    // params.end_time = parseInt(this.formSearch.endTime) / 1000;

    if (this.branchId) {
      params.branch_id = this.branchId;
    }
    customerExport(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private settingColumnItem = false
  private columnItemData: any = {
    all: { name: '全选', value: '0', checked: true },
    customer: { name: '客户', value: '1', checked: true },
    orderall: { name: '总订单', value: '2', checked: true },
    orderallBranch: { name: '分公司总订单', value: '3', checked: true },
    finished: { name: '已完成', value: '4', checked: true },
    closed: { name: '已关闭', value: '5', checked: true },
    closeCompany: { name: '公司关单', value: '6', checked: true },
    closeCustomer: { name: '客户关单', value: '7', checked: true },
    send: { name: '送修', value: '8', checked: true },
    remote: { name: '远程', value: '9', checked: true },
    door: { name: '上门', value: '10', checked: true },
    express: { name: '寄修', value: '11', checked: true },
    other: { name: '其他', value: '12', checked: true },
    averageResponse: { name: '平均响应时长', value: '13', checked: true },
    averageRepair: { name: '平均维修时长', value: '14', checked: true },
    operation: { name: '操作', value: '15', checked: true }
  }
  private showHideColumn() {
    this.settingColumnItem = !this.settingColumnItem;
  }
  private setColumnItem() {
    this.settingColumnItem = true;
  }

  created() {
    let body = document.documentElement || document.body;
    body.addEventListener('click', (e: any) => {
      if (e.target.id !== 'getColumnItemBtn') {
        this.settingColumnItem = false;
      }
    }, false);
    let dataStrStart = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + '1 00:00:00';
    let dataStrEnd = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + (new Date().getDate() === 1 ? 1 : (new Date().getDate() - 1)) + ' 23:59:59';
    this.formSearch.timePeriods = [ new Date(dataStrStart).getTime(), new Date(dataStrEnd).getTime() ];
    // this.formSearch.startTime = new Date(dataStrStart).getTime();
    // this.formSearch.endTime = new Date(dataStrEnd).getTime();
    this.getList();
  }
  //
  private SelectCus(cus:any) {
    this.formSearch.customer = cus;
  }
  private getList() {
    let orderParams:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSizes
    };
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      orderParams.start_time = this.formSearch.timePeriods[0] / 1000;
      orderParams.end_time = this.formSearch.timePeriods[1] / 1000;
    }
    // orderParams.start_time = this.formSearch.startTime / 1000;
    // orderParams.end_time = this.formSearch.endTime / 1000;

    if (this.formSearch.customer && this.formSearch.customer.customer_company_id) {
      orderParams.customer_company_id = this.formSearch.customer.customer_company_id;
    }
    if (this.formSearch.customer && this.formSearch.customer.customer_user_id) {
      orderParams.customer_user_id = this.formSearch.customer.customer_user_id;
    }
    if (this.formSearch.name) {
      orderParams.name = this.formSearch.name;
    }
    if (this.branchId) {
      orderParams.branch_id = this.branchId;
    }
    this.loading = true;
    getCustomerList(orderParams).then(res => {
      if (res && res.data) {
        this.pagination.total = parseInt(res.data.count);
        this.tableData = res.data.list;
      } else {
        this.pagination.total = 0;
        this.tableData = [];
      }
      this.loading = false;
    }).catch(err => {
      if (!err.data) {
        this.tableData = [];
        this.loading = false;
      }
    }
    );
  }

  private handleDetail(row: any) {
    this.$router.push({
      path: '/Statistics/customerDetail',
      query: { 'customer': JSON.stringify(row) }
    });
  }
  private branchId=''
  private handleBranch(row:any) {
    this.branchId = row.customer_company_id;
    this.getList();
  }

  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  private handleClear() {
    this.formSearch = {
      name: '',
      timePeriods: '',
      startTime: '',
      endTime: '',
      customer: {}
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
